import React from "react";
import SimpleSlider from "../component/SimpleSlider";

// import "swiper/css/swiper.min.css";

const ServiceCrausal = () => {
  return <SimpleSlider />;
};

export default ServiceCrausal;
